import { scan } from "@pdfking/rfunc"

import state from "../state/main"

export default (key, value) => scan((v, k) => (state[key][k] = v), value)
